import CloseIcon from "@mui/icons-material/Close";
import SeleccionTipoPlanificacionGIF from "../img/Seleccion_TipoPlanificacion.gif";
import CampoHorasSemanaGIF from "../img/Campo_HorasSemana.gif";
import CampoSemanasGIF from "../img/Campo_semanas.gif";
import CampoTemaGIF from "../img/Campo_tema.gif";
import {
  Box,
  Button,
  Divider,
  FormLabel,
  Grid,
  Modal,
  Typography,
} from "@mui/material";
import { FC } from "react";

// Estilos para el Modal de ayuda
const styleModalHelp = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "60%",
  height: "80%",
  bgcolor: "background.paper",
  borderRadius: 2,
  boxShadow: 24,
  p: 4,
  overflow: "auto",
};

interface Props {
  open: boolean;
  onClose: () => void;
}

const NameHelp: FC<Props> = ({ open, onClose }) => {
  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={styleModalHelp}>
        <Button
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </Button>
        <Typography
          id="modal-modal-title"
          variant="h4"
          component="h2"
          marginBottom={5}
          sx={{ textAlign: "center", fontFamily: "Inter", fontWeight: "bold" }}
        >
          Cómo utilizar la sección de Tema, duración de la planificación
        </Typography>
        <Grid container spacing={2}>
          <Grid item xs={12} md={6}>
            <img
              src={SeleccionTipoPlanificacionGIF}
              alt="Ejemplo"
              style={{
                position: "relative",
                width: "100%",
                height: "300px",
                objectFit: "contain",
              }}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <Typography
              id="modal-modal-title"
              variant="h6"
              sx={{ textAlign: "center", fontFamily: "Robot Slab" }}
            >
              Selección tipo de planificación
            </Typography>
            <FormLabel component="p" sx={{ fontFamily: "Inter", m: 0, pb: 2 }}>
              Este campo se refiere al enfoque o categoría de la planificación
              que estás registrando.
            </FormLabel>
          </Grid>

          <Grid item xs={12}>
            <Divider sx={{ my: 2 }} />
          </Grid>

          <Grid item xs={12} md={6}>
            <Typography
              id="modal-modal-title"
              variant="h6"
              sx={{ textAlign: "center", fontFamily: "Robot Slab" }}
            >
              {" "}
              Tema{" "}
            </Typography>
            <ul>
              <FormLabel
                component="p"
                sx={{ fontFamily: "Inter", m: 0, pb: 2 }}
              >
                En el tema del proyecto puedes escribir sobre el contenido
                prioritario de los objetivos elegidos. Por ejemplo:
              </FormLabel>
              <FormLabel
                component="p"
                sx={{ fontFamily: "Inter", m: 0, pb: 2 }}
              >
                • Proyecto sobre Grecia.
              </FormLabel>
              <FormLabel
                component="p"
                sx={{ fontFamily: "Inter", m: 0, pb: 2 }}
              >
                • Proyecto sobre reciclaje.
              </FormLabel>
            </ul>
          </Grid>
          <Grid item xs={12} md={6}>
            <img
              src={CampoTemaGIF}
              alt="Ejemplo"
              style={{
                position: "relative",
                width: "100%",
                height: "300px",
                objectFit: "contain",
              }}
            />
          </Grid>

          <Grid item xs={12}>
            <Divider sx={{ my: 2 }} />
          </Grid>

          <Grid item xs={12} md={6}>
            <img
              src={CampoSemanasGIF}
              alt="Ejemplo"
              style={{
                position: "relative",
                width: "100%",
                height: "300px",
                objectFit: "contain",
              }}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <Typography
              id="modal-modal-title"
              variant="h6"
              sx={{ textAlign: "center", fontFamily: "Robot Slab" }}
            >
              Cantidad de semanas
            </Typography>
            <ul>
              <FormLabel
                component="p"
                sx={{ fontFamily: "Inter", m: 0, pb: 2 }}
              >
                Selecciona el total de semanas que debe cubrir esta
                planificación.
              </FormLabel>
            </ul>
          </Grid>

          <Grid item xs={12}>
            <Divider sx={{ my: 2 }} />
          </Grid>

          <Grid item xs={12} md={6}>
            <Typography
              id="modal-modal-title"
              variant="h6"
              sx={{ textAlign: "center", fontFamily: "Robot Slab" }}
            >
              {" "}
              Horas semanales{" "}
            </Typography>
            <ul>
              <FormLabel
                component="p"
                sx={{ fontFamily: "Inter", m: 0, pb: 2 }}
              >
                Selecciona el total de horas pedagógicas que cada semana se
                dedicará a la implementación de esta planificación.
              </FormLabel>
            </ul>
          </Grid>
          <Grid item xs={12} md={6}>
            <img
              src={CampoHorasSemanaGIF}
              alt="Ejemplo"
              style={{
                position: "relative",
                width: "100%",
                height: "300px",
                objectFit: "contain",
              }}
            />
          </Grid>
        </Grid>
      </Box>
    </Modal>
  );
};

export default NameHelp;
